import * as Yup from "yup";

const FILE_SIZE = 20 * 1024 * 1024;

const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "application/pdf",
];

const getValidationSchema = (collectionTypeId, editVehicleData) => {
  // console.log("Validation Schema for collectionTypeId:", collectionTypeId); // Debugging
 
  let baseSchema = {
    vehicleNumber: Yup.string()
      .required("Vehicle Number is required")
      .max(14, "Vehicle Number cannot exceed 12 characters"),
    chassisNumber: Yup.string()
      .max(30, "Chassis Number cannot exceed 30 characters")
      .matches(
        /^[a-zA-Z0-9 ]*$/,
        "Chassis Number can only contain letters and numbers"
      ),
    fuelTypeId: Yup.string().required("Fuel Type is required"),
    vehicleTypeId: Yup.string().required("Vehicle Type is required"),
    vehicleCapacityId: Yup.string().required("Vehicle Capacity is required"),
    driverId: Yup.string().required("Driver is required"),
    collectionTypeId: Yup.string().required("Collection Type is required"),
    vehicleStatusId: Yup.string().required("Vehicle Status is required"),
    ownerTypeId: Yup.string().required("Owner Type is required"),
    vehicleUuid: Yup.string()
      .required("Vehicle UID is required")
      .max(20, "Vehicle UID cannot exceed 20 characters"),
    zoneId: Yup.string().required("Zone is required"),
    isActive: Yup.boolean().required("Active status is required"),
     mappings: Yup.array()
      .of(
        Yup.object().shape({
          startingCollectionPointId: Yup.string()
            .required('Start Route Point is required'),
          endingCollectionPointId: Yup.string()
            .required('End Route Point is required'),
          shifts: Yup.array()
            .min(1, 'At least one shift must be selected')
            .required('At least one shift is required')
        })
      )
      .min(1, 'At least one trip is required'),
    vehicleImageUrl: Yup.mixed()
      .nullable()
      .test("fileSize", "File too large", (value) => {
        return !value || (value && value.size <= FILE_SIZE);
      })
      .test("fileType", "Unsupported file format", (value) => {
        return !value || (value && SUPPORTED_FORMATS.includes(value.type));
      }),

    rcimageUrl: Yup.mixed()
      .nullable()
      .test("fileSize", "File too large", (value) => {
        return !value || (value && value.size <= FILE_SIZE);
      })
      .test("fileType", "Unsupported file format", (value) => {
        return !value || (value && SUPPORTED_FORMATS.includes(value.type));
      }),

    pcimageUrl: Yup.mixed()
      .nullable()
      .test("fileSize", "File too large", (value) => {
        return !value || (value && value.size <= FILE_SIZE);
      })
      .test("fileType", "Unsupported file format", (value) => {
        return !value || (value && SUPPORTED_FORMATS.includes(value.type));
      }),
  };
 
  if ([1, 2].includes(Number(collectionTypeId))) {
    console.log("Adding required validations for circleId and wardId"); // Debugging
    baseSchema.circleId = Yup.string().required("Ward is required");
  }
 
  if (collectionTypeId === "1") {
    baseSchema.wardId = Yup.string().required("Ward is required");
    baseSchema.primaryDeploymentInchargeId = Yup.string().required(
      "SFA Incharge is required"
    );
  }
 
  if (collectionTypeId === "2") {
    baseSchema.driverId = Yup.string();
    baseSchema.secondaryDeploymentInchargeId = Yup.string();
    // baseSchema.transferStationId = Yup.string().required(
    //   "Transfer Station is required"
    // );
  }

  
  if (collectionTypeId === "1") {
    baseSchema.driverId = Yup.string().required("Driver is required");
  } else {
    baseSchema.driverId = Yup.string(); // Optional for all other collection types
  }
 
  if (collectionTypeId === "3") {
    baseSchema.driverId = Yup.string();
    baseSchema.transferStationId = Yup.string();
  }
 
  return Yup.object().shape(baseSchema);
};

export default getValidationSchema;
